let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("h5Eq0")]).then(() => parcelRequire('8IuF3'));